export default __webpack_public_path__ + "static/media/how-lawyerup-works.a5ad93c6.mp4";